<template>
    <div class="card">
        <card>
            <div class="d-flex justify-content-between border-bottom pb-1 mb-5">
                <h4 slot="header" class="card-title">{{ this.$route.params.id === undefined ? 'Ajout' : 'Modification' }}
                    d'un
                    fournisseur</h4>
                <n-button slot="header" type="primary" class="btn btn-sm btn-primary mt-4 h-25"
                    @click.native="backToList()">
                    Retour
                </n-button>
            </div>

            <div class="row align-items-center justify-content-center">
                <div class="col-lg-4">
                    <div class="card" style="height: -webkit-fill-available">
                        <div class="card-header">
                            <h5 class="mb-0 text-center"> Informations fournisseurs</h5>
                        </div>
                        <div class="card-body" style="min-height: 250px">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="mb-3">
                                        <label for="name" class="input-label">
                                            Fournisseur
                                        </label>
                                        <fg-input id="name" v-model="supplier.name"></fg-input>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="mb-3">
                                        <label for="reference" class="input-label">
                                            Référence
                                        </label>
                                        <fg-input id="reference" v-model="supplier.num"></fg-input>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="mb-0">
                                        <label class="input-label">Note interne</label>
                                        <fg-input name="body" v-model="supplier.comment">
                                            <textarea class="form-group input-group resizing" id="intern_note"
                                                name="intern_note" style="padding-left: 16px; font-size: 13px;"
                                                v-model="supplier.comment" rows="8" maxlength="255"
                                                placeholder="Informations concernant le fournisseur">
                                            </textarea>
                                        </fg-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

                <div class="col-lg-4">
                    <div class="card" style="height: -webkit-fill-available">
                        <div class="card-header">
                            <h5 class="mb-0 text-center"> Liste des produits</h5>
                        </div>
                        <div class="card-body">
                            <div v-if="supplier.products.length === 0" class="no-contact">
                                <p> Aucun produit</p>
                            </div>
                            <div v-if="supplier.products.length > 0" class="contact-list" style="min-height: 200px">
                                <div class="card mb-2" v-for="(product, index) in supplier.products" :key="index"
                                    style="height: fit-content">
                                    <div class="card-body d-flex align-items-center">

                                        <div class="avatar mr-2 d-flex justify-content-center align-items-center" style="border-radius: 5px">
                                           <img style="max-width: 75%" src="../../../../assets/img/product.png"/>
                                        </div>

                                        <div class="contact-body">
                                            <div class="information">
                                                  <div class="contact d-flex">
                                                    <i class="fas fa-box ml-3 mr-3 d-flex align-items-center"></i>
                                                    <p class="mb-0"><strong>{{ product.name }}</strong></p>
                                                  </div>
                                                  <div class="contact d-flex">
                                                    <i class="fas fa-hashtag ml-3 mr-3 d-flex align-items-center"></i>
                                                    <p class="mb-0">{{ product.reference }}</p>
                                                  </div>
                                            </div>

                                            <div class="action-list d-flex justify-content-end">
                                                <div class="action mr-3" @click="editProduct(product)">
                                                    <i class="fas fa-edit"></i>
                                                </div>
                                                <div class="action" @click="removeProduct(index)">
                                                    <i class="fas fa-trash-alt"></i>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="add-contact" @click="productModal = true">
                                <i class="fas fa-plus" style="color: #B2B2B2"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="card" style="height: -webkit-fill-available">
                        <div class="card-header">
                            <h5 class="mb-0 text-center"> Liste des contacts</h5>
                        </div>
                        <div class="card-body">
                            <div v-if="supplier.contacts.length === 0" class="no-contact">
                                <p> Aucun contact</p>
                            </div>
                            <div v-if="supplier.contacts.length > 0" class="contact-list" style="min-height: 200px">
                                <div class="card mb-2" v-for="(contact, index) in supplier.contacts" :key="index"
                                    style="height: fit-content">
                                    <div class="card-body d-flex align-items-center">

                                        <div class="avatar d-flex justify-content-center align-items-center">
                                            <p class="mb-0">{{ getInitials(contact.name) }}</p>
                                        </div>

                                        <div class="contact-body">

                                            <div class="information">
                                                <div class="contact d-flex">
                                                    <i class="fas fa-user ml-3 mr-3 d-flex align-items-center"></i>
                                                    <p class="mb-0">{{ contact.name }}</p>
                                                </div>
                                                <div class="contact d-flex">
                                                    <i class="fas fa-phone ml-3 mr-3 d-flex align-items-center"></i>
                                                    <p class="mb-0">{{ contact.phone }}</p>
                                                </div>
                                                <div class="contact d-flex">
                                                    <i class="fas fa-at ml-3 mr-3 d-flex align-items-center"></i>
                                                    <p class="mb-0">{{ contact.email }}</p>
                                                </div>

                                            </div>

                                            <div class="action-list d-flex justify-content-end">
                                                <div class="action mr-3" @click="editContact(contact)">
                                                    <i class="fas fa-edit"></i>
                                                </div>
                                                <div class="action" @click="removeContact(index)">
                                                    <i class="fas fa-trash-alt"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="add-contact" @click="contactModal = true">
                                <i class="fas fa-plus" style="color: #B2B2B2"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <n-button class="btn btn-sm btn-primary radius" @click.native="save()">
                        Enregistrer
                    </n-button>
                </div>
            </div>

        </card>

        <modal :show.sync="contactModal" headerClasses="justify-content-center">
            <h4 slot="header" class="mt-0">{{ contact.id === '' ? 'Créer votre contact' : 'Modifier votre contact' }}</h4>

            <div class="row">
                <div class="col-lg-6">
                    <label for="name" class="input-label">
                        Nom & Prénom
                    </label>
                    <fg-input id="contact_name" name="contact_name" v-model="contact.name" v-validate="'required'"
                        :error="errors.first('contact_name')" />
                </div>
                <div class="col-lg-6">
                    <label for="phone" class="input-label">
                        N° de téléphone
                    </label>
                    <fg-input id="contact_phone" name="contact_phone" v-model="contact.phone" v-validate="'required'"
                        :error="errors.first('contact_phone')" />
                </div>
                <div class="col-lg-12">
                    <label for="phone" class="input-label">
                        Email
                    </label>
                    <fg-input id="contact_email" name="contact_email" v-model="contact.email" v-validate="'required'"
                        :error="errors.first('contact_email')" />
                </div>
            </div>

            <div class="row justify-content-around">
                <button class="col-5 btn btn-sm btn-secondary radius" @click="contactModal = false">Retour</button>
                <button class="col-5 btn btn-sm btn-primary radius" @click="addContact()">Enregistrer</button>
            </div>
        </modal>

        <modal :show.sync="productModal" headerClasses="justify-content-center">
            <h4 slot="header" class="mt-0">{{ contact.id === '' ? 'Créer votre produit' : 'Modifier votre produit' }}</h4>

            <div class="row">
              <div class="col-12">
                <div class="mb-2">
                  <label for="product" class="input-label">
                    Produit
                  </label>
                  <fg-input class="select" name="product_id" v-model="products.selected">
                    <el-select id="product" placeholder="Choisir un product"
                               v-model="products.selected" filterable clearable>
                      <el-option v-for="product in products.options" :key="product.id"
                                 v-if="!gotProduct(product.id)"
                                 :label="product.name" :value="product.id">
                      </el-option>
                    </el-select>
                  </fg-input>
                </div>
              </div>
                <div class="col-lg-6">
                    <label for="name" class="input-label">
                        Nom
                    </label>
                    <fg-input id="product_name" name="product_name" v-model="product.name" v-validate="'required'"
                        :error="errors.first('product_name')" />
                </div>
                <div class="col-lg-6">
                    <label for="reference" class="input-label">
                        Référence
                    </label>
                    <fg-input id="product_reference" name="product_reference" v-model="product.reference"
                        v-validate="'required'" :error="errors.first('product_reference')" />
                </div>
            </div>

            <div class="row justify-content-around">
                <button class="col-5 btn btn-sm btn-secondary radius" @click="productModal = false">Retour</button>
                <button class="col-5 btn btn-sm btn-primary radius" @click="addProduct()">Enregistrer</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Form from 'vform'
import { Modal } from 'src/components'
import { Select, Option } from 'element-ui'

export default {
    name: 'SupplierForm',
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            contact_select: false,

            contactModal: false,

            productModal: false,

            contact: new Form({
                id: '',
                email: '',
                name: '',
                phone: '',
                supplier_id: ''
            }),

            product: new Form({
                id: '',
                name: '',
                reference: '',
                supplier_id: ''
            }),

            supplier: new Form({
                id: '',
                num: '',
                name: '',
                comment: '',
                products: [],
                contacts: []
            }),

            contacts: {
                options: []
            },

            products: {
                selected: null,
                options: []
            },

            suppliers: []
        }
    },
    watch: {
        contactModal(newValue, oldValue) {
            if (!newValue) {
                this.resetContactForm()
            }
        },
        productModal(newValue, oldValue) {
          this.products.selected = null;
            if (!newValue) {
                this.resetProductForm()
            }
        },
        'products.selected'(newValue, oldValue) {
            if (newValue !== null) {
              this.products.options.forEach( option => {
                if(option.id === newValue){
                  this.product.id = option.id
                  this.product.reference = option.reference
                  this.product.name = option.name
                }
              })
            }
        },
    },
    mounted() {
        //récupération du détail d'un fournisseur pour la modification
        if (this.$route.params.id !== undefined) {
            this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/supplier/` + this.$route.params.id).then((response) => {
                let supplier = response.data

                this.supplier.id = this.$route.params.id
                this.supplier.num = supplier.num
                this.supplier.name = supplier.name
                this.supplier.comment = supplier.comment
                this.supplier.contacts = supplier.contacts
                this.supplier.products = supplier.products
            })
        } else {
            this.getSupplierNum()
        }

        // Remplir "product" avec un appel GET Axios
        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/product/list`).then((response) => {
            this.products.options = response.data
        })

        this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/contact/list`).then((response) => {
            this.contacts.options = response.data
        })

    },
    methods: {
        addContact() {
            const fieldsToValidate = ['contact_name', 'contact_phone', 'contact_email'];
            let errors = 0

            Promise.all(
                fieldsToValidate.map(field => this.$validator.validate(field))
            ).then(responses => {

                responses.forEach(response => {
                    if (!response) {
                        errors++;
                    }
                });

                if (errors === 0) {
                    const newContact = {
                        id: this.contact.id !== '' ? this.contact.id : 'New',
                        name: this.contact.name,
                        phone: this.contact.phone,
                        email: this.contact.email
                    };

                    if (this.contact.id !== '') {
                        const index = this.supplier.contacts.findIndex(contact => contact.id === this.contact.id);
                        this.supplier.contacts[index] = newContact;
                    } else {
                        this.supplier.contacts.push(newContact);
                    }


                    this.resetContactForm();
                    this.contactModal = false;
                }
            });

        },
        editContact(contact) {
            this.contact.id = contact.id
            this.contact.name = contact.name
            this.contact.email = contact.email
            this.contact.phone = contact.phone

            this.contactModal = true
        },
        removeContact(contact_index) {
            this.supplier.contacts.splice(contact_index, 1);
        },
        resetContactForm() {
            this.contact.id = ''
            this.contact.name = ''
            this.contact.email = ''
            this.contact.phone = ''

            this.errors.remove('contact_name')
            this.errors.remove('contact_phone')
            this.errors.remove('contact_email')

        },

        gotProduct(product_id){

          var owned = false;

          this.supplier.products.forEach(product => {
            if(product.id === product_id){
              owned = true;
            }
          })

          return owned;
        },

        addProduct() {
            const fieldsToValidate = ['product_name', 'product_reference'];
            let errors = 0

            Promise.all(
                fieldsToValidate.map(field => this.$validator.validate(field))
            ).then(responses => {

                responses.forEach(response => {
                    if (!response) {
                        errors++;
                    }
                });

                if (errors === 0) {
                    const newProduct = {
                        id: this.product.id !== '' ? this.product.id : 'New',
                        name: this.product.name,
                        reference: this.product.reference,
                    };

                    this.supplier.products.push(newProduct);

                    this.resetProductForm();
                    this.productModal = false;
                }
            });

        },
        editProduct(product) {
            this.product.id = product.id
            this.product.name = product.name
            this.product.reference = product.reference

            this.productModal = true
        },
        removeProduct(product_index) {
            this.supplier.products.splice(product_index, 1);
        },
        resetProductForm() {
            this.product.id = ''
            this.product.name = ''
            this.product.reference = ''

            this.errors.remove('product_name')
            this.errors.remove('product_reference')
        },

        getInitials(name) {
            const names = name.split(' ');
            const initials = names.map(name => name[0]).join('');
            return initials;
        },

        // Fonction permettant d'incrémenter le num d'une Fnc
        getSupplierNum() {
            this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/supplier/ref`).then((response) => {
                this.supplier.num = response.data
            })
        },

        backToList() {
            this.$router.push({ name: 'fnc admin', params: { selected: "supplier" } })
        },

        save() {
            //fonction permettant la modification d'un fournisseur
            if (this.$route.params.id !== undefined) {
                this.supplier.post(process.env.VUE_APP_API_BASE_URL + `supplier/update/` + this.$route.params.id).then((response => {
                    this.$notify({ message: 'Le fournisseur à bien été mmodifié', type: "success", verticalAlign: "bottom" })
                    this.backToList()
                }))
                //fonction permettant l'ajout d'un fournisseur 
            } else {
                this.supplier.post(process.env.VUE_APP_API_BASE_URL + `supplier/add`).then((response => {
                    this.$notify({ message: 'Le fourniseur à bien été enregistré', type: "success", verticalAlign: "bottom" })
                    this.backToList()
                }))
            }
        }
    },
}
</script>

<style>
.contact-list {
    max-height: 205px;
    padding: 5px;
    overflow: auto;
}

.add-contact {
    cursor: pointer;
    border: 1px dashed #B2B2B2;
    height: 35px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

}

.add-contact:hover {
    box-shadow: 1px 1px #B2B2B2;
    background: rgba(161, 159, 159, 0.25);
}

.no-contact {
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: -webkit-fill-available;
}

.no-contact p {
    color: #B2B2B2;
    font-size: 16px;
}

.contact {
    color: #5b5b5b;
}

.avatar {
    border-radius: 25px;
    background: #B2B2B2;
}

.avatar p {
    color: white;
    font-size: 20px;
}

.action {
    font-size: large;
    color: #B2B2B2;
    cursor: pointer;
}

.action:hover {
    color: #656565;
    cursor: pointer;
}

.contact-body {
    display: flex;
    justify-content: space-between;
    width: 90%;
}

.el-tag {
    margin-bottom: 10px !important;
}
</style>